<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'Breadcrumbs',
  computed: {
    // breadcrumbs() {
    //     const crumbs = [];
    //     let route = this.$route;
    //
    //     while (route) {
    //         const match = this.$router.options.routes.find(r => r.name === route.name);
    //         if (!match || !match.meta || !match.meta.breadcrumb) break;
    //
    //         const label = typeof match.meta.breadcrumb === 'function'
    //             ? match.meta.breadcrumb(route)
    //             : match.meta.breadcrumb;
    //
    //         // Replace params in path
    //         let path = match.path;
    //         Object.entries(route.params).forEach(([key, val]) => {
    //             path = path.replace(`:${key}`, val);
    //         });
    //
    //         crumbs.unshift({ label, path });
    //
    //         const parentName = match.meta.parent;
    //         if (parentName) {
    //             route = {
    //                 name: parentName,
    //                 params: this.$route.params, // для простоти
    //             };
    //         } else {
    //             break;
    //         }
    //     }
    //
    //     return crumbs;
    // }
    breadcrumbs() {
      const crumbs = [];

            const findRouteByName = (routes, name) => {
                for (const route of routes) {
                    if (route.name === name) return route;
                    if (route.children) {
                        const found = findRouteByName(route.children, name);
                        if (found) return found;
                    }
                }
                return null;
            };

            let current = this.$route;

            while (current && current.name) {
                const match = findRouteByName(this.$router.options.routes, current.name);
                if (!match || !match.meta || !match.meta.breadcrumb) break;

                const label = typeof match.meta.breadcrumb === 'function'
                    ? match.meta.breadcrumb(current)
                    : match.meta.breadcrumb;

                let path = match.path;
                // замінюємо :params в path
                Object.entries(this.$route.params).forEach(([key, val]) => {
                    path = path.replace(`:${key}`, val);
                });

                crumbs.unshift({ label, path });

                if (!match.meta.parent) break;

                current = { name: match.meta.parent };
            }

            return crumbs;
        }
    },
})
</script>

<template>
    <nav class="breadcrumbs">
        <ul>
            <li>
              <router-link to="/">
                Головна
              </router-link>
            </li>
            <li v-for="(crumb, index) in breadcrumbs" :key="index">
                <router-link v-if="index !== breadcrumbs.length - 1" :to="crumb.path">
                    {{ crumb.label }}
                </router-link>
                <span v-else>{{ crumb.label }}</span>
            </li>
        </ul>
    </nav>
</template>

<style scoped lang="scss">
.breadcrumbs {
    ul {
        display: flex;
        list-style: none;
        gap: 0.5rem;
        margin: 0;
        margin-block-start: 0;
        padding-inline-start: 0;
        li {
            display: flex;
            font-family: Geist, sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #D4D4D8;

            a {
                color: #D4D4D8;
            }
        }
        li:last-child {
            color: #09090B;
        }
        li::after {
            content: '/';
            margin-left: 0.5rem;
        }
        li:last-child::after {
            content: '';
        }
    }
}
</style>
